<template>
    <div class="matchmacking-container">
        <header-default :loader="loader" :clock="true" :clockTime="timerView" v-if="showHeader"></header-default>
        <alert-match-making @closeAlert="closeAlert" v-if="alertShow" :timeToInit="timeToInit"></alert-match-making>
        <router-view :formedGroup="formedGroup" :candidates="candidates" :timeToInit="timerView" :loader="loader"></router-view>
        <loader-full v-if="showLoader"></loader-full>
    </div>
</template>
<script>
import moment from 'moment'
moment.locale('pt-br');
import Bus from '../main.js'
import decodeApi from '../api/decode.js'
import firebase from '../firebase/firebase.js'
import Firebase from 'firebase'
import AlertMatchMaking from '../components/Alerts/AlertMatchMaking.vue'
import HeaderDefault from '../components/Sections/HeaderDefault.vue'
import LoaderFull from '../components/Loaders/LoaderFull'
import {tagManager} from "../helpers/integrationManager"
export default {
    components:{
        AlertMatchMaking,
        HeaderDefault,
        LoaderFull
    },
    data(){
        return{
            timerView : '',
            intervalId : '',
            alertShow : false,
            showHeader : false,
            showLoader : false,
            timeToInit : '',
            loader : true,
            candidates : '',
            formedGroup : '',
            db : '',
        }
    },
    async created(){
        await firebase.destroyedApp()
        Bus.$on('sendMessage', this.sendMessage)
        const { groupId, group, player } = await this.$store.getters.getSimple(['groupId', 'group', 'player'])
        const db = firebase.constructDB()
        this.db = db
        this.watchGroup(db, groupId, group, player)
        this.initializeClock()
        let routeName = ''
        let self = this
        window.addEventListener("focus", function(){
            routeName = self.$route.name
            if(!self.intervalId){
                if(routeName == 'rules' || routeName == 'match-making' || routeName == "chat-initial" || routeName == "waiting-room"){
                    self.initializeClock()
                }
            }
        })
        window.addEventListener("blur", function(){
            routeName = self.$route.name
            if(routeName == 'rules' || routeName == 'match-making' || routeName == "chat-initial" || routeName == "waiting-room"){
                clearInterval(self.intervalId)
                self.intervalId = ''
                self.timerView = ''
                self.loader = true
            }
        })
    },
    methods : {
        async sendMessage(chatId, newMessage){
            const { teamGameId } = await this.$store.getters.getSimple(['teamGameId']) 
            // const teamGameId = undefined
            // console.log("teamGameId: ", teamGameId)
            this.db.collection('teamGames').doc(teamGameId).update({
                "messages": Firebase.firestore.FieldValue.arrayUnion(newMessage)
            })
        },
        async socketsConnect(teamGameId){
            let messages = []
            let messagesLength = 0
            let firstAcess = true
            let self = this
            try {
                this.db.collection('teamGames').doc(teamGameId).onSnapshot(snapshot => {
                let messagesBot = localStorage.getItem('messagesBot')
                messagesBot = JSON.parse(messagesBot)
                let messagesSnap = messagesBot ? messagesBot : []
                if(snapshot.exists && snapshot.data().messages){
                    snapshot.data().messages.forEach(message => {
                        messagesSnap.push(message)
                    })
                }
                messages = messagesSnap
                if(messagesBot && messagesBot.length >= 7){
                    if(firstAcess){
                        firstAcess = false
                        self.$store.dispatch('simpleSave', {
                            messages
                        })
                        messagesLength = snapshot.data().messages.length
                        Bus.$emit('scrollToBottomMessage')
                        return
                    }
                    let chatMessages = document.querySelector('.chat-messages');
                    let scrollMax = 180
                    let scrollElement = chatMessages.scrollTop
                    let chatViewHeight = chatMessages.clientHeight
                    let heightMax = chatMessages.clientHeight + 100
                    if(messagesLength < snapshot.data().messages.length){
                        if(chatMessages.scrollHeight - scrollElement >= heightMax){
                            Bus.$emit('countMessage')
                        }else{
                            Bus.$emit('scrollToBottomMessage')
                        }
                        self.$store.dispatch('simpleSave', {
                            messages
                        })
                        messagesLength = snapshot.data().messages.length
                    }
                }else{
                    let messagesCache = []
                    if(snapshot.data() && snapshot.data().messages){
                        snapshot.data().messages.forEach(message => {
                            messagesCache.push(message)
                        })
                        localStorage.setItem('messagesCache', JSON.stringify(messagesCache))
                    }
                }
                firstAcess = false
            })
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.error("error on socket connect function: ", error)
                let { teamGameId, groupId, group, userId } = await this.$store.getters.getSimple(['teamGameId', 'groupId', 'group', 'userId'])
                let errorBody = { teamGameId, groupId, group, userId }
                errorBody.workspaceId = localStorage.getItem("workspaceId")
                errorBody.firebaseError = error
                errorBody.line = "129"
                errorBody.file = "MatchMakingContainer.vue"
                // console.log("errorBody: ", errorBody)
                
                const { data: res } = await decodeApi.post(`/logs`,errorBody)
            }
        },
        async watchGroup(db, groupId, group, player){
            db.collection('groups').doc(groupId).onSnapshot(async snapshot => {
                const { players, teamGameId, ping, groupStatus } = snapshot.data()
                if(!group){
                    group = players
                }
                if(teamGameId && teamGameId[0]){
                    this.$store.dispatch('simpleSave', {
                        group : players,
                        teamGameId : teamGameId[0]
                    })
                    this.socketsConnect(teamGameId[0])
                }
                this.candidates = await this.organizeGroup(snapshot.data().players) 
            })
        },
        async pingIndex(ping, player){
            let pingIndex = ''
            // console.log(ping)
            ping.forEach((playerPing, index) => {
                if(playerPing.id == player.id) pingIndex = index;
            })
            return pingIndex == 0 || pingIndex ? pingIndex : false
        },
        async organizeGroup(group){
            const { userId } = await this.$store.getters.getSimple(['userId'])
            let groupReturn = []
            let [ selfPlayer ] = group.filter(player => { return player.id == userId })
            groupReturn.push(selfPlayer)
            if(group.length > 1){
                group.forEach(player => {
                    if(player.id != userId){
                        groupReturn.push(player)
                    }
                })
            }
            return groupReturn
        },
        async initializeClock(){
            const { sessionId, groupId, player } = this.$store.getters.getSimple(['sessionId', 'groupId', 'player'])
            this.defineHeader()
            // console.log("sessionId: ", sessionId)
            const session = await this.getSession(sessionId)
            const sessionDate = moment(session.schedule)
            const sessionStart = sessionDate.add(15, 'minutes')
            const now = await this.getNow()
            let startGame = sessionStart.diff(now, 'seconds')
            let diffHours = sessionStart.diff(now, 'hours')
            let diffDays = sessionStart.diff(now, 'days')
            if(startGame < 0 || diffHours < 0 || diffDays <= -1){ //acabou os 15 min iniciais (sala de espera)
                // console.log("sessionId antes da requisção: ", sessionId)
                const groups = await decodeApi.get(`/groups?userId=${player.id}&sessionId=${sessionId}`)
                // console.log("get groups: ", groups)
                let responseGroupId = ''
                if(!groups.data.groups.length){
                    responseGroupId = groups.data.groups.id
                }else{
                    // responseGroupId = groups.data.groups[groups.data.groups.length - 1].id
                    responseGroupId = groups.data.groups[0].id
                }
                await this.$store.dispatch('simpleSave', {
                    "groupId" : responseGroupId
                })
                // console.log("responseGroupId: ", responseGroupId)
                await this.endGame()
                return
            }
            let timer = moment("2015-01-01").startOf('day').seconds(startGame);
            this.intervalId = setInterval(async () => {
                timer = timer.subtract(1, 'seconds')
                this.loader = false
                this.timerView = timer.format('mm:ss')
                if(this.timerView == '05:00' || this.timerView == '03:00' || this.timerView == '01:00'){
                    this.alertTime(this.timerView)
                }
                if(this.timerView <= '00:00'){
                    await this.endGame()
                }
            }, 1000);
        },
        defineHeader(){
            this.$route.name != 'chat-initial' ? this.showHeader = true : this.showHeader = false
        },
        async getNow(){
            const responseNow = await decodeApi.get('/team-games/now')
            let now = moment(responseNow.data).tz('America/Sao_Paulo').format()
            return now
        },
        async getSession(sessionId){
            const session = await decodeApi.get(`/sessions/${sessionId}`)
            return session.data.session
        },
        alertTime(time){
            this.alertShow = true
            this.timeToInit = time
        },
        closeAlert(){
            this.alertShow = false
        },
        async endGame(){
            let self = this
            this.showLoader = true
            clearInterval(this.intervalId)
            const { groupId, player } = this.$store.getters.getSimple(['groupId', 'player'])
            const group = await this.db.collection('groups').doc(groupId).get()
            if(group.data().players.length < 3){
                // console.log("Calling reallocate function")
                await this.reallocateGroup(groupId, player)
                return
            }
            // const workspaceId = localStorage.getItem("workspaceId")
            // if(this.$store.getters.getWsWithTagManager.includes(workspaceId)){
            //     console.log("Entrou no if da Gupy")
            //     const { data: player } = JSON.parse(localStorage.getItem("player"))
            //     delete player.cpf
            //     const tag = "Finalizou o Decode Game"
            //     await tagManager(tag ,workspaceId, player)
            // }            
            await this.goCreateGame()
        },
        async reallocateGroup(groupId, currentPlayer){
            await this.pingGroup(groupId, currentPlayer)
            let unsubscribe = ''
            let callReallocate = false
            setTimeout(async () => {
                unsubscribe = this.db.collection('groups').doc(groupId).onSnapshot(async snapshot => {
                    const { players, teamGameId, ping, groupStatus } = snapshot.data()
                    // logica de host/ping
                    if(ping){
                        const pingIndex = await this.pingIndex(ping, currentPlayer)
                        const validPing = pingIndex === 0 || pingIndex
                        // console.log(pingIndex)
                        if(validPing && !callReallocate){
                            this.reallocateHost(pingIndex, groupId)
                            callReallocate = true
                        }
                    }
                    // logica de reallocate
                    if(groupStatus){
                        await this.messageReallocate(groupStatus, currentPlayer)
                        clearTimeout(this.timeoutId._id)
                        // this.timeoutId._clearFn()
                        unsubscribe()
                    }
                })
            }, 1000)
        },
        async reallocateHost(pingIndex, groupId){
            // console.log(pingIndex)
            this.timeoutId = setTimeout(async () => {
                const responseReallocate = await decodeApi.patch(`/groups/${groupId}/reallocate`)
                // console.log(responseReallocate)
            }, pingIndex * 10000)
        },
        async pingGroup(groupId, currentPlayer){
            const newPing = await this.db.collection('groups').doc(groupId).update({
                "ping": Firebase.firestore.FieldValue.arrayUnion(currentPlayer)
            })
        },
        async messageReallocate(message, player){
            if(message == "suggest rescheduling"){
                Bus.$emit('openAlertGlobal', {
                    imageSrc : 'error',
                    title : 'Não foi possível encontrar um grupo.',
                    subtitle : 'Porém existem sessões em aberto, reagende um novo horário. :)',
                    route : 'dashboard'
                })
            }
            if(message == 'suggest contacting us'){
                Bus.$emit('openAlertGlobal', {
                    imageSrc : 'error',
                    title : 'Não foi possível encontrar um grupo.',
                    subtitle : 'Entre em contato conosco através do e-mail: support@huddlebrasil.zendesk.com :)',
                    route : 'dashboard'
                })
            }
            if(message == 'reallocated' || message == 'successfully reallocated'){
                const {sessionId} = await this.$store.getters.getSimple(['sessionId'])
                const group = await decodeApi.get(`/groups?userId=${player.id}&sessionId=${sessionId}`)
                // console.log("New reallocated group: ", group)
                let groups = group.data.groups
                let responseGetGroup = ''
                if(groups.length){
                    responseGetGroup = groups.filter(grupo => {
                        return !grupo.fields.groupStatus
                    })
                    responseGetGroup = responseGetGroup[0]
                }
                // console.log("responseGetGroup: ", responseGetGroup)
                // console.log("responseGetGroup.fields.teamGameId: ", responseGetGroup.fields.teamGameId)
                await this.$store.dispatch('simpleSave', {
                    "groupId" : responseGetGroup.id,
                    "teamGameId" : responseGetGroup.fields.teamGameId[0],
                    "group" : responseGetGroup.fields.players
                })
                
                await this.goCreateGame()
            }
            if(message == 'release the duo' 
            || message == "it's not necessary to reallocate players, because this group has more than 2 players"
            || message == "it's not necessary to reallocate players, because this group already has passed by reallocate"){
                await this.goCreateGame()
            }
            if(!message){
                await this.goCreateGame()
            }
        },
        async goCreateGame(){
            const workspaceId = localStorage.getItem("workspaceId")
            await firebase.destroyedApp()
            if(!localStorage.getItem("alreadyBeginTag") && await this.$store.getters.getWsWithTagManager.includes(workspaceId)){
                // console.log("Iniciou Game pelo MM Container")
                const { data: player } = JSON.parse(localStorage.getItem("player"))
                delete player.cpf
                const tag = "Iniciou o Decode Game"
                localStorage.setItem("alreadyBeginTag", true)
                await tagManager(tag ,workspaceId, player)
            }   
            this.$router.push('/game')
        }
    },
    beforeRouteUpdate(to, from, next){
        to.name != 'chat-initial' ? this.showHeader = true : this.showHeader = false
        next()
    }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width : 750px) {
    .matchmacking-container{
        height: 100%;
    }
}
    
</style>
